export default __webpack_public_path__ + "static/media/S_sound.63ad6b8f.mp3";